import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type ListFilter,
  type MultiFilter,
} from '../types/filters';
import { ethnicityDefinition, ethnicityHandler } from './ethnicity';

export const multiEthnicityDefinition: FilterDefinition<
  MultiFilter<ListFilter>
> = {
  id: FilterId.MULTI_ETHNICITY,
  name: 'Ethnicity',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.ETHNICITY,
  instances: [],
  isVisible: true,
};

export const multiEthnicityHandler: FilterHandler<MultiFilter<ListFilter>> = {
  isActive(currentFilterState: MultiFilter<ListFilter>) {
    return currentFilterState.instances.some((instance) =>
      ethnicityHandler.isActive(instance)
    );
  },

  isDefault(
    currentFilterState: MultiFilter<ListFilter>,
    _definition: FilterDefinition<MultiFilter<ListFilter>>
  ) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<ListFilter>,
    _definition: FilterDefinition<MultiFilter<ListFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      ethnicityHandler.getEffectiveFilter(instance, ethnicityDefinition, config)
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
